import { ModicaPhoneNumberInput } from "@modica-library/input-phone/react";

type PhoneDetail = {
  value?: string;
  formattedValue?: string;
  formatE164?: string;
  isValid?: boolean;
  country?: string;
};

type Props = {
  label?: string;
  value?: string;
  /** Called with the raw value; `detail` carries the component's validation/format info. */
  onChange?: (value: string, detail?: PhoneDetail) => void;
  error?: string;
  assistiveText?: string;
  placeholder?: string;
  className?: string;
  /** Show the flag/country dropdown. */
  enableCountrySelector?: boolean;
  /** ISO country code, e.g. "NZ". */
  country?: string;
};

// The generated wrapper only types the event props, but @lit/react forwards any
// prop through to the `modica-input-phone-number` element — widen it locally.
const Phone = ModicaPhoneNumberInput as unknown as (props: Record<string, unknown>) => ReturnType<
  typeof ModicaPhoneNumberInput
>;

/** Thin wrapper over @modica-library/input-phone, preserving our (label/value/error string) API. */
export function InputPhone({
  label,
  value,
  onChange,
  error,
  assistiveText,
  placeholder,
  className,
  enableCountrySelector,
  country,
}: Props) {
  return (
    <Phone
      label={label ?? "Mobile Number"}
      value={value ?? ""}
      onEventOnInputPhone={(e: any) => {
        const detail = (e?.detail ?? {}) as PhoneDetail;
        onChange?.(detail.value ?? e?.target?.value ?? "", detail);
      }}
      error={!!error}
      errorMessage={error}
      assistiveText={assistiveText}
      placeholder={placeholder}
      enableCountrySelector={enableCountrySelector}
      country={country}
      autocomplete="tel"
      inputmode="tel"
      className={className}
    />
  );
}
